import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cx_foundations-help_center_comprehensive_csat-submit';

/**
 * Event tracked when users click on the help-center CSAT form that we will show, initially, on the answer page of the self-serve flow when customers report dissatisfaction

Replaces cx_foundations-self_serve_comprehensive_csat-submit which does not capture all the fields we need
 */
export function trackCxFoundationsHelpCenterComprehensiveCsatSubmit(
  issue: string,
  brandOrderToken: string,
  instant_answer_available2: string,
  help_articles3: string,
  last_help_article_visited4: string,
  csat_score5: string,
  csat_reasons6: string,
  csat_custom_reason7: string,
  brandToken: string,
  retailerToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: {
      issue,
      brandOrderToken,
      instant_answer_available2,
      help_articles3,
      last_help_article_visited4,
      csat_score5,
      csat_reasons6,
      csat_custom_reason7,
      brandToken,
      retailerToken,
    },
  });
}
